import { IToaNha } from "./../../../model/respone/category/IToaNha";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eToaNhaActionsObj = {
  LOAD_START: undefined,
  LOAD_SUCCESS: {} as IToaNha[],
  LOAD_ERRR: "",
  SHOW_EDIT_MODAL: {} as IToaNha | undefined,
  CLOSE_EDIT_MODAL: undefined,
  SAVE_START: {} as IToaNha,
  SAVE_SUCCESS: undefined,
  SAVE_ERRR: "",
  DELETE_START: 0,
  DELETE_SUCCESS: undefined,
  DELETE_ERRR: "",
};

export const eToaNhaActionIds = generateActionTypeIds(
  eToaNhaActionsObj,
  "TOA_NHA"
);
export type IToaNhaActionTypes = IGenericActionType<
  typeof eToaNhaActionsObj,
  "TOA_NHA"
>;
